import api from "../api/axios";

export const submitDocketEntry = (data) =>
  api.post("/api/dockets/create-docket", data);

export const getDocketEntries = (params) => {
  if (typeof params === 'string' || !params) {
    return api.get(`/api/dockets/get-dockets`, { params: { branchCode: params } });
  }
  return api.get(`/api/dockets/get-dockets`, { params });
};

export const updateDocketEntry = (id, data) =>
  api.put(`/api/dockets/update-docket-status/${id}`, data);

export const getDocketEntryById = (id) =>
  api.get(`/api/dockets/get-docket/${id}`);

export const getNextDocketNo = () =>
  api.get("/api/dockets/generate-next-docket-no");
